import http from "./http";

export type BagSizeItem = {
	key: "small" | "medium" | "large";
	title: string;
	description: string;
	image: string;
};

const BAG_SIZE_DEFAULTS: BagSizeItem[] = [
	{ key: "small", title: "Small bag", description: "Backpack, handbag", image: "/static/img/book/bag-small.svg" },
	{
		key: "medium",
		title: "Standard suitcase",
		description: "Carry-on, travel bag",
		image: "/static/img/book/bag-medium.svg",
	},
	{
		key: "large",
		title: "Oversized",
		description: "Surfboard, golf bag, large box",
		image: "/static/img/book/bag-large.svg",
	},
];

function mergeWithDefaults(sizes: BagSizeItem[]): BagSizeItem[] {
	const keys: Array<"small" | "medium" | "large"> = ["small", "medium", "large"];
	return keys.map((key) => {
		const stored = sizes.find((s) => s.key === key);
		const def = BAG_SIZE_DEFAULTS.find((d) => d.key === key)!;
		if (!stored) return { ...def };
		return {
			key: stored.key,
			title: stored.title ?? def.title,
			description: stored.description ?? def.description,
			image: stored.image ?? def.image,
		};
	});
}

export async function getBagContent(): Promise<BagSizeItem[]> {
	const { data } = await http.get("/utility/bag-size-config");
	const sizes: BagSizeItem[] = data?.data?.sizes ?? data?.sizes ?? [];
	return mergeWithDefaults(sizes);
}

export async function saveBagContent(sizes: BagSizeItem[]): Promise<void> {
	await http.post("/utility/bag-size-config", { sizes });
}

/**
 * Upload a single bag content image to GCS.
 * Field name: "image" (matches existing PartnerService / TopDestinationService pattern).
 * Returns the public URL.
 */
export async function uploadBagImage(file: File): Promise<string> {
	const formData = new FormData();
	formData.append("image", file);
	const { data } = await http.post("/gcs-upload-single-image?folder=bag-content", formData, {
		headers: { "Content-Type": "multipart/form-data" },
	});
	const url = data?.url || data?.path || data?.previewUrl;
	if (!url) {
		throw new Error("Upload succeeded but no URL returned.");
	}
	return url as string;
}
